import { Icon, Text, HStack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { Pressable } from 'native-base';
import React from 'react';

interface VisitLegacyPageProps {
  onPress: () => void;
}

export const VisitLegacyPage: React.FC<VisitLegacyPageProps> = ({ onPress }) => {
  const buttonText = useBreakpointValue({ base: 'VERSÃO ANTERIOR', sm: 'VER VERSÃO ANTERIOR' });

  return (
    <Pressable onPress={onPress}>
      <HStack alignItems="center" space="inline.nano">
        <Icon name="ArrowLeft" size="xxs" color="brand.tertiary.principal" padding={0} />
        <Text variant="semibold" color="brand.tertiary.principal">
          {buttonText}
        </Text>
      </HStack>
    </Pressable>
  );
};
